module.exports = __webpack_public_path__ + "static/media/bg-logos.cd454beb.png";